import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetArtistProfilePhotoListRequest } from '@/shared/api/requests/photo/artist-photo-list/request';
import { getArtistProfilePhotoList } from '@/shared/api/requests/photo/artist-photo-list/request';

export const useArtistProfilePhotoListQuery = (
  params: GetArtistProfilePhotoListRequest,
  settings?: QuerySettings<typeof getArtistProfilePhotoList>
) =>
  useQuery({
    queryKey: ['ArtistProfilePhotoList', params.profileId, params.tag],
    queryFn: () =>
      getArtistProfilePhotoList({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
